import React, { Component } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Typography,
    Link,
} from "@mui/material";
import { applications } from "./ApiCommonService";
import { GetBrokerApplicationsById } from "../ApiSevices/QuoteCompareAPI";

interface IProps {
    onAppSelect: (applicationId: number) => void;
    allowedMenus: string[];
}
interface IAppSwitchState {
    loading: boolean;
    apps: any[];
}

export default class AppSwitch extends Component<IProps, IAppSwitchState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            apps: [],
        };
    }

    onApplicationSelect = (applicationId: number) => {
        this.props.onAppSelect(applicationId);
    };

    componentDidMount(): void {
        this.fetchApplications();
    }

    fetchApplications = async () => {
        this.setState({ loading: true });
        try {
            const applications = await GetBrokerApplicationsById();
            this.setState({ apps: applications || [] });
        } catch (error) {
            console.error("Error fetching applications:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    renderCard = (
        title: string,
        heading: string,
        description: React.ReactNode,
        logoUrl: string | undefined,
        applicationId: number
    ) => (

        <Card
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    textAlign: "center",
                    py: 1.5,
                    fontWeight: 600,
                    fontSize: "18px",
                }}
            >
                {title}
            </Box>

            <CardContent sx={{ flex: 1, paddingBottom: 0 }}>
                <Grid container spacing={2}>
                    {/* Heading + Logo row */}
                    <Grid item xs={12}>
                        <Grid container alignItems="center">
                            <Grid item xs>
                                <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                    {heading}
                                </Typography>
                            </Grid>

                            <Grid item>
                                {
                                    logoUrl &&
                                    <img
                                        src={logoUrl}
                                        alt={title}
                                        style={{
                                            height: 40,
                                            width: "auto",
                                            border: "1px solid #dee2e6",
                                        }}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Description - full width */}
                    <Grid item xs={12}>
                        <Typography sx={{ fontSize: "14px", color: "#333" }}>
                            {description}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>

            {/* Footer Button */}
            <Box sx={{ px: 2, pb: 2 }}>
                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        backgroundColor: "#2b2f6c",
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: "#24285d",
                        },
                    }}
                    disabled={title === "Quote Compare" ? !this.state.apps.includes(title) : false}
                    onClick={() => this.onApplicationSelect(applicationId)}
                >
                    {title === "Quote Compare" ? this.state.apps.includes(title) ? "Take me there" : "Please contact support to subscribe" : "Take me there"}
                </Button>
            </Box>
        </Card>
    );

    render() {
        const { loading, apps } = this.state;
        const year = new Date().getFullYear();
        const hasUserMaster = this.props?.allowedMenus?.includes("UserMaster");
        const filteredApplications = hasUserMaster
            ? applications
            : applications.filter(app => app.applicationId !== 3); // Exclude User Management app

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                {!loading &&
                    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                        {/* Main Content */}
                        <Box sx={{ flex: 1, px: 3, pt: "65px" }}>
                            <Typography className="card-header">
                                Exdion Istudio Suite
                            </Typography>

                            <Box
                                sx={{
                                    overflowY: "auto",
                                    height: '70vh',
                                }}
                            >
                                <div className="app-grid">
                                    {filteredApplications.map((card) => (
                                        <div key={card.applicationId}>
                                            {this.renderCard(
                                                card.title,
                                                card.heading,
                                                card.description,
                                                card.logo,
                                                card.applicationId || 0
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </Box>
                        </Box>

                        {/* Footer */}
                        <Box
                            sx={{
                                borderTop: "1px solid #e0e0e0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                backgroundColor: "#fff",
                                px: 2,
                            }}
                        >
                            <img
                                src="logos\Exdion iSTUDIO Logo.jpg"
                                alt="Exdion Edge"
                                style={{ height: "52px", padding: '4px' }}
                            />

                            <Typography sx={{ fontSize: "13px", color: "#555" }}>
                                © {year} - Exdion Edge -{" "}
                                <Link
                                    href="https://exdionedge.app/helpfiles/PrivacyPolicy.pdf"
                                    underline="hover"
                                >
                                    Privacy
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                }
            </>
        );
    }
}
